import Modernizr from 'modernizr';
import WebFont from "webfontloader";
import ImagesLoaded from "imagesloaded";
import { sum } from 'math';
import 'jquery.easing';
import 'lazysizes';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

// ここに処理を書いていく👇
$(() => {

	// Check behavior//*
	console.log($.fn);//OK
	console.log(Modernizr);//OK
	console.log(ImagesLoaded);//OK
	console.log(WebFont.load);//OK
	console.log(process.env.NODE_ENV);
	sum(1,2);// sub(),mul()の分はTreeShakingされるはず！！！！

	function bg(){
		let bgimage;
		let title;
		if (window.matchMedia( '(min-width: 860px)' ).matches) {
			$('.projects-thumb').hover(
				function(){
					bgimage = $(this).data('bg');
					title = $(this).data('title');
					$('body').addClass('bg-active');
					$('#bg').stop().css('background-image', '').delay(50).queue(function() {
						$('#bg').addClass('active').css('background-image', 'url('+bgimage+')').dequeue();
					});
					$('#bg-title').text(title);
				},
				function(){
					$('#bg').stop().removeClass('active');
					$('body').removeClass('bg-active');
					$('#bg-title').text('');
				}
			)
		}else{};
	}
	function spMenu(){
		$('#sp-button').on('click', function() {
			$(this).toggleClass('active');
			$('.menu').toggleClass('active');
		});
	}
	function spCredit(){
		if (window.matchMedia( '(min-width: 860px)' ).matches) {
		}else{
			$('.sp-credit-toggle').on('click', function() {
				$(this).toggleClass('active');
				$('.credit-wrapper').slideToggle();
			});
		}
	}

	function replaceHeadTags(target) {
		const $newPageHead = $('<head />').html(
			$.parseHTML(
				target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0],
				document,
				true
				)
			);
		const headTags = [
		"meta[name='robots']",
		"meta[name='keywords']",
		"meta[name='description']",
		"meta[property^='og']",
		"meta[name^='twitter']",
		"meta[itemprop]",
		"link[rel='next']",
		"link[rel='prev']",
		"link[rel='alternate']",
		"link[rel='canonical']",
		"script[type='application/ld+json']"
		].join(',');
		// タグを削除
		$('head').find(headTags).remove();
		// タグを追加
		$newPageHead.find(headTags).appendTo('head');
	
		//Googleアナリティクスに送信
		if (typeof ga === 'function') {
			ga('send', 'pageview', location.pathname);
		}
	}

	spMenu();
	spCredit();
	bg();

	// barba.use(barbaPrefetch);
	// barba.init({
	// 	transitions: [
	// 		{
	// 			async leave({ current, next, trigger }) {
	// 				// replaceHeadTags(next);
	// 			}
	// 		}
	// 		]
	// });

});


// WEBPACK FOOTER //
// ./build/assets/js/scripts.js